import { mapState, mapMutations, mapGetters } from 'vuex'
import { MODULE_NAME } from '@/store/locations/constants'
import authService, { USER_ROLES } from '@/api/authService'
import {
  MODULE_NAME as MODULE_NAME_FILTERS,
  MUTATIONS as MUTATIONS_FILTERS,
  GETTERS as GETTERS_FILTER
} from '@/store/filters/constants'
import debounce from '@/utils/debounce'

export default {
  name: 'PanelCenters',
  mixins: [],
  components: {
    CenterListItem: () => import(/* webpackChunkName: "CenterListItem" */ '@/components/center-list-item/CenterListItem.vue'),
    MapViewportSwitch: () => import(/* webpackChunkName: "MapViewportSwitch" */ '@/components/map-viewport-switch/MapViewportSwitch.vue')
  },
  props: {
    centers: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      authData: authService.authData,
      touched: false,
      searchText: ''
    }
  },
  computed: {
    ...mapState(MODULE_NAME, ['viewportFilter']),
    ...mapGetters(MODULE_NAME_FILTERS, {
      filterText: GETTERS_FILTER.GET_SHOPS_FILTERS
    }),
    filteredCenters () {
      if (!this.viewportFilter.enabled) {
        return this.centers
      }
      return this.viewportFilter.shops
    },

    isAdmin () {
      return this.authData.user.role === USER_ROLES.ROOT ||
        this.authData.user.role === USER_ROLES.CENTRAL_ADMIN ||
        this.authData.user.role === USER_ROLES.AGENCY_PATRIMONY
    }
  },
  methods: {
    ...mapMutations(MODULE_NAME_FILTERS, [ MUTATIONS_FILTERS.SET_SHOPS_FILTER_VALUE ]),
    onScroll ({ y }) {
      const scrollThreshold = 0.9
      const el = this.$refs.scrollbar.scroller
      const maxY = el.scrollHeight - el.offsetHeight
      if (!this.loading && y > (maxY * scrollThreshold)) {
        this.$emit('nextPage')
      }
    },
    filter (event) {
      this.touched = true
      const value = event.target.value
      this.updateFilter(value, this)
    },
    // set debounce on keyup
    updateFilter: debounce(function (value, that) {
      that.touched = false
      that[MUTATIONS_FILTERS.SET_SHOPS_FILTER_VALUE]({ value })
    }, 500),
    clear () {
      this.touched = false
      this[MUTATIONS_FILTERS.SET_SHOPS_FILTER_VALUE]({ value: '' })
    }
  }
}
